import IDMUtils from '../IDMUtils';
//
import CookiesLocal from './_CookiesLocal';
import CookiesRemote from './_CookiesRemote';
import CookiesMem from './_CookiesMem';
/**
 *
 */
export default class Cookies {

  /**
   * constructor - description
   *
   * @return {type}  description
   */
  constructor(endpoint, datasource) {
    this.endpoint = endpoint;
    this.datasource = datasource;
    this.cookieEngine = null; 
    this.initializing = null;
  }

  /**
   * cleanKey - description
   *
   * @param  string | string[] key description
   * @return {type}     description
   */
  async cleanKey(key) { 
    await this.__initializeEngine();
    return this.cookieEngine.cleanKey(key);
  }

  /**
   * getValue - description
   *
   * @param  {type} key description
   * @return {type}     description
   */
  async getValue(key) { 
    await this.__initializeEngine();
    return this.cookieEngine.getValue(key);
  }

  /**
   * setDefaultValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setDefaultValue(key, val) {
    await this.__initializeEngine();
    return this.cookieEngine.setDefaultValue(key, val);
  }

  /**
   * setLongLiveValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setLongLiveValue(key, val) {
    await this.__initializeEngine();
    return this.cookieEngine.setLongLiveValue(key, val);
  }

  /**
   * setValue - description
   *
   * @param  {type} key  description
   * @param  {type} val  description
   * @param  {type} ttl description
   * @return {type}      description
   */
  async setValue(key, val, ttl) {
    await this.__initializeEngine();
    return this.cookieEngine.setValue(key, val, ttl);
  }

  async __initializeEngine() {
    //
    if (!this.cookieEngine) {
      //Enqueue if initializing
      if (!this.initializing) this.initializing = [];
      else return new Promise((resolve) => {
        this.initializing.push(resolve);
      });
      //Initialize engine
      if (IDMUtils.isSafari()) {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Using local cookies engine.');
        this.cookieEngine = new CookiesLocal();
      } else if (IDMUtils.isNodeJS()) {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Using in-memory cookies engine.');
        this.cookieEngine = new CookiesMem();
      } else {
        if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Using remote cookies engine.');
        //Attempt to use
        const cookieEngine = new CookiesRemote(this.endpoint);
        if (!(await cookieEngine._connect())) {
          if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Failed to load remote cookies engine, falling back to local!');
          this.cookieEngine = new CookiesLocal();
        } else {
          //Further test
          try {
            const wtest = await cookieEngine.setValue('test', true, 100);
            if (wtest && wtest.toLowerCase().includes('error')) {
              if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Failed to write on remote cookies engine, falling back to local!');
              this.cookieEngine = new CookiesLocal();
            } else this.cookieEngine = cookieEngine;
          } catch (e) {
              if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug('Failed to write on remote cookies engine, falling back to local!.');
              this.cookieEngine = new CookiesLocal();
          }
        }
      }
      //Fullfill initialize queue
      for (let cb of this.initializing) cb();
      this.initializing = null;
    }
  }
}
